import { render } from "./ProsesPilihanJawaban.vue?vue&type=template&id=51a5ff82"
import script from "./ProsesPilihanJawaban.vue?vue&type=script&lang=js"
export * from "./ProsesPilihanJawaban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__